module.exports = __webpack_public_path__ + "static/fonts/GroteskDemiRegular.1eca48c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GroteskDemiRegular.eot
// module id = EmL9
// module chunks = 0